import { foodImage } from "@/assets";

const Template2 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const fallback = (value, defaultText) => {
    if (value === null || value === undefined || value === "") {
      return isStrictPreview ? "" : defaultText;
    }
    return value;
  };

  const backgroundImage =
    template?.image_url ||
    template?.image?.file_url ||
    template?.file_url ||
    previewData?.image_url ||
    previewData?.image?.file_url ||
    previewData?.template?.image_url ||
    previewData?.template?.image?.file_url ||
    foodImage;
  const title = fallback(previewData?.title, "Points Award");
  const customerName = fallback(previewData?.customerName, "Roin Tanduri");
  const code = fallback(previewData?.code, "32154232");
  const rewardLabel = fallback(previewData?.rewardLabel, "Double Points");
  const eligiblePoints = fallback(previewData?.eligibleRewardPoints, "50");
  const minimumRequiredPoints = fallback(previewData?.minimumRequiredPoints, "5");
  
  const isDiscount = rewardLabel.includes("£") || rewardLabel.includes("%") || rewardLabel.toLowerCase().includes("off");
  const offerSentence = rewardLabel 
    ? (isDiscount ? `For ${eligiblePoints} points get ${rewardLabel} off` : `For ${eligiblePoints} points get ${rewardLabel}`)
    : `For ${eligiblePoints} points get reward`;
  const eligibilitySentence = `Minimum ${minimumRequiredPoints} points to be eligible for this offer`;

  const message = fallback(previewData?.message || previewData?.template_note, "Wish you a happy day.");
  const isConjunction = previewData?.isConjunction ?? previewData?.is_conjunction ?? (isStrictPreview ? false : true);

  return (
    <div className="flex items-center justify-center p-4">
      <div
        data-export-capture="point-based-template"
        className="relative w-full max-w-2xl h-[300px] shadow-2xl overflow-hidden rounded-sm flex bg-[#7A5408]"
      >
        <div
          className="w-[35%] h-full bg-cover bg-center border-r-2 border-black/20"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        ></div>

        <div className="w-[65%] h-full flex flex-col items-start justify-between text-white p-6 pt-8 pb-6">
          <div className="w-full">
            <h1 className="text-2xl font-bold tracking-tight leading-none mb-0.5">
              {title}
            </h1>
            <p className="text-base font-serif italic text-gray-100 opacity-95 mb-2">
              {customerName}
            </p>
            <div className="flex flex-wrap gap-2 text-xs">
              <span className="bg-black/25 px-2 py-0.5 rounded">Code: {code}</span>
              {rewardLabel && (
                <span className="bg-yellow-500/30 text-yellow-300 px-2 py-0.5 rounded font-semibold">
                  Offer: {rewardLabel}
                </span>
              )}
            </div>
          </div>

          <div className="my-1.5">
            <h2 className="text-2xl font-extrabold tracking-tight leading-tight text-yellow-400 mb-1">
              {offerSentence}
            </h2>
            <p className="text-xs text-gray-200 font-medium">
              {eligibilitySentence}
            </p>
          </div>

          <div className="w-full">
            {message ? (
              <p className="text-xs italic text-gray-300 opacity-90 line-clamp-1 max-w-sm">
                {message}
              </p>
            ) : (
              <div className="h-3" />
            )}
            {isConjunction && (
              <p className="text-[10px] text-yellow-300 opacity-95 font-semibold mt-0.5">
                Not conjunction with any other offer
              </p>
            )}
          </div>
        </div>

        <div className="absolute inset-0 border-[8px] border-black/10 pointer-events-none"></div>
      </div>
    </div>
  );
};

export default Template2;
